var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"email-message-template-textareas"},_vm._l((_vm.textareaBindings),function(textarea){return _c('template-text-area',{key:textarea.fieldName,ref:textarea.fieldName,refInFor:true,staticClass:"email-message-template-textareas__paragraph default-email-message-template__paragraph",class:{ 'error-input-border': _vm.getIsBodyPartOneFieldError(textarea.fieldName) },attrs:{"value":textarea.value,"maxlength":textarea.maxLength,"field-name":textarea.fieldName,"required":""},on:{"input":function($event){return _vm.onTextareaFieldInput({
        ...$event,
        isTextarea: true,
        refName: textarea.fieldName,
        isSmsCampaign: _vm.isSmsCampaign
      })},"change":_vm.onTextareaFieldChange}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }